import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "number-ticker flex-row flex-justify-center" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "of-max flex-center"
}
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "ticker-btn flex-center",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onUpdate(_ctx.value - 1))),
      disabled: _ctx.value <= _ctx.min || _ctx.disableSub
    }, _cache[5] || (_cache[5] = [
      _createElementVNode("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        _createElementVNode("path", {
          d: "M4 12C4 11.4477 4.44772 11 5 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H5C4.44772 13 4 12.5523 4 12Z",
          fill: "currentColor"
        })
      ], -1)
    ]), 8, _hoisted_2),
    (_ctx.ofMax)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.value) + " of " + _toDisplayString(_ctx.max), 1)
        ]))
      : _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 1,
          type: "number",
          placeholder: "0",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputValue) = $event)),
          onBlur: _cache[2] || (_cache[2] = ($event: any) => ($event.target.value = _ctx.inputValue)),
          onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.$emit('onEnter')), ["enter"]))
        }, null, 544)), [
          [_vModelText, _ctx.inputValue]
        ]),
    _createElementVNode("button", {
      class: "ticker-btn",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onUpdate(_ctx.value + 1))),
      disabled: _ctx.value == _ctx.max || _ctx.disableAdd
    }, _cache[6] || (_cache[6] = [
      _createElementVNode("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        _createElementVNode("path", {
          d: "M12 4C11.4477 4 11 4.44772 11 5V11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H11V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H13V5C13 4.44772 12.5523 4 12 4Z",
          fill: "currentColor"
        })
      ], -1)
    ]), 8, _hoisted_4)
  ]))
}